











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TextInput extends Vue {
  @Prop({ required: false }) readonly invalid?: boolean;

  handleInput (event: any) {
    this.$emit('input', event.target.value)
  }

  handleBlur (event: FocusEvent) {
    this.$emit('blur', event)
  }
}
